import { createFileRoute } from '@tanstack/react-router';

import { DbTablesTab } from '../../../components/DbTablesTab';

export const Route = createFileRoute('/db-insights/tables/')({
  component: DbTablesTab
});
